<template>
  <div>
    <label v-if="label" class="block mb-2 text-sm" :for="name">{{
      label
    }}</label>
    <fieldset :name="name" :class="containerClass">
      <slot />
      <label
        :for="name + index"
        class="flex items-center space-x-2"
        v-for="(option, index) in options"
        :key="option.id"
      >
        <Field
          class="border border-gray-200"
          type="radio"
          :value="option.id"
          :id="name + index"
          :name="name"
          v-model="model"
          :disabled="disabled"
        />
        <span>{{ option.name }}</span>
      </label>
    </fieldset>
    <ErrorMessage class="mt-2 text-xs text-red-500" :name="name" />
  </div>
</template>

<script>
import { Field, ErrorMessage } from "vee-validate";
import { computed } from "vue";
import { useStore } from "vuex";

export default {
  name: "Radio",
  components: { Field, ErrorMessage },
  props: {
    name: {
      required: true,
      type: String,
    },
    containerClass: {
      required: false,
      default: () => "flex space-x-3",
      type: String,
    },
    label: {
      required: false,
      default: () => null,
      type: String,
    },
    disabled: {
      required: false,
      default: () => false,
      type: Boolean,
    },
    rules: {
      required: false,
      default: () => null,
      type: Function,
    },
    options: {
      required: true,
      type: Array,
    },
  },
  setup({ name }) {
    const store = useStore();

    const model = computed({
      get() {
        return store.getters.resolve(name);
      },
      set(value) {
        store.commit("set", { name, value });
      },
    });

    return {
      model,
    };
  },
};
</script>
